module.exports = __webpack_public_path__ + "static/media/changelog.cc897cf9.graphql";